// extracted by mini-css-extract-plugin
export default {"bg":"mrPP2R"};